import { User, Bell, Lock, HelpCircle, LogOut, ChevronRight } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function SettingsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const isRetailerPath = location.pathname.includes("/retailer-dashboard");
  const basePath = isRetailerPath ? "/retailer-dashboard/settings" : "/farmer-dashboard/settings";

  return (
    <div className="settings-container-apss">
      <h1 className="settings-title-apss">Settings</h1>
      
      <div className="settings-cards-apss">
        {/* Account Settings Card */}
        <Link to={`${basePath}/account`} className="settings-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss account-icon-apss">
              <User size={24} color='#fff' />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Account Settings</h3>
              <p className="settings-card-description-apss">Update your profile information</p>
            </div>
          </div>
          <ChevronRight className="settings-chevron-apss" size={20} />
        </Link>
        
        {/* Notifications Card */}
        <Link to={`${basePath}/notifications`} className="settings-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss notification-icon-apss">
              <Bell size={24} color='#fff' />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Notifications</h3>
              <p className="settings-card-description-apss">Configure your notification preferences</p>
            </div>
          </div>
          <ChevronRight className="settings-chevron-apss" size={20} />
        </Link>
        
        {/* Privacy & Security Card */}
        <Link to={`${basePath}/privacy&security`} className="settings-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss security-icon-apss">
              <Lock size={24} color='#fff' />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Privacy & Security</h3>
              <p className="settings-card-description-apss">Manage your password and security settings</p>
            </div>
          </div>
          <ChevronRight className="settings-chevron-apss" size={20} />
        </Link>
        
        {/* Help & Support Card */}
        <Link to={`${basePath}/help`} className="settings-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss help-icon-apss">
              <HelpCircle size={24} color='#fff' />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Help & Support</h3>
              <p className="settings-card-description-apss">Get help with your Agrictech  account</p>
            </div>
          </div>
          <ChevronRight className="settings-chevron-apss" size={20} />
        </Link>
        
        {/* Logout Card */}
        <button 
          className="settings-card-apss logout-card-apss"
          onClick={async () => {
            await logout();
            navigate('/');
          }}
          style={{
            background: 'inherit',
            border: 'inherit',
            width: '100%',
            cursor: 'pointer',
            textAlign: 'left'
          }}
        >
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss logout-icon-apss">
              <LogOut size={24} color="#fff" />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Logout</h3>
              <p className="settings-card-description-apss">Sign out of your account</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}